import { useMemo } from 'react';
import { DrugInfo } from '@customTypes/drugs';
import { hasGuidance } from '@helpers/drug';

export const useDrug = (drug: DrugInfo) => {
  const areasOfGuidance = useMemo(() => hasGuidance(drug), [drug]);
  return areasOfGuidance;
};
